export const getYearDifference = (years: number) =>
	Math.min(3, Math.max(0, years - 1));
